import * as React from 'react';
import { StyledInformationalPage } from '../../common/static.styles';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

// @todo
const seo = {
  description: '',
};

const title = 'Sobre Nosotros';

export default () => (
  <DefaultLayout seo={seo} locale='es-EM'>
    <HeadTitle title={title} />
    <StyledInformationalPage>
      <div className='content'>
        <article>
          <h1>{title}</h1>
          <p>
            <strong>WARNER BROS. ENTERTAINMENT</strong> es un líder mundial en todos los tipos de entretenimiento y sus
            empresas relacionadas a través de todos los medios y plataformas actuales y emergentes. De Time Warner
            Company, el Estudio, está a la vanguardia de cada aspecto de la industria del entretenimiento, desde
            largometrajes, televisión, producciones de entretenimiento en casa y distribución mundial, hasta DVD y
            Blu-ray, distribución digital, videojuegos, animaciones, licenciamiento de productos y marca, y
            teledifusión. DC Entertainment, la empresa detrás de los más icónicos superhéroes del mundo, incluidos
            Batman, Superman, Mujer Maravilla, Flash y muchos más, también es parte de Warner Bros.{' '}
          </p>
          <p>
            Warner Bros. Studios fue fundado cuando los cuatro hermanos, Albert, Sam, Harry y Jack L. Warner,
            incorporaron su nueva compañía de cine, el 4 de Abril de 1923. En 1927, con el estreno de »El cantante de
            jazz«, el primer largometráje con sonido sincronizado,se marcó el rumbo para la inovación e influencia que
            pronto se convertirían en sinónimos del nombre Warner Bros.
          </p>
          <p>
            Desde aquellos momentos, Warner Bros. Studios ha acumulado un legado impresionante, mientras también creaba
            una diversa empresa de entretenimiento de amplitud y profundidad incomparable. La regularidad y el éxito de
            la compañía a largo plazo, están basados en un manejo estable a través de toda su historia, relaciones
            creativas duraderas con muchos de los principales productores y estrellas del mundo, y una constante
            dedicación a la excelencia.
          </p>
          <p>
            Hoy en día, la librería de Warner Bros., una de las más prestigiosas y valiosas del mundo, consiste en más
            de 79.000 horas de programación, incluyendo cerca de 7.500 largometrajes y 4.500 programas de televisión,
            que se componen de miles de episodios individuales. El Estudio, también gestiona una de las más exitosas
            colecciones de marcas y franquicias del mundo.
          </p>
        </article>
      </div>
    </StyledInformationalPage>
  </DefaultLayout>
);
